export default class UserSearch {
    constructor (dto) {
        this.id = 0;
        this.name = '';
        this.conditionStr = '';
        this.groupStr = '';
        this.sortStr = '';
        this.isParameterizable = false;
        this.addToExternalApps = false;
        this.contentTypeIDs = [];
        this.searchAllVersions = false;
        this.contentTypeIDsIsLastVersion = [];

        if (dto) {
            this.id = dto.Id;
            this.name = dto.FilterName;
            this.conditionStr = dto.FilterStr;
            this.groupStr = dto.GroupStr;
            this.sortStr = dto.SortStr;
            this.isParameterizable = dto.IsParameterizable;
            this.addToExternalApps = dto.IsBasket;
            this.contentTypeIDs = dto.ContentTypeIDs == '' ? [] : dto.ContentTypeIDs.split(',');
            this.searchAllVersions = dto.SearchAllVersions;
            this.contentTypeIDsIsLastVersion = Array.isArray(dto.ContentTypeIDsIsLastVersion)
                ? dto.ContentTypeIDsIsLastVersion.map(id => id.toString())
                : [];
        }
    }

    toDto () {
        return {
            Id: this.id,
            FilterName: this.name,
            FilterStr: this.conditionStr,
            GroupStr: this.groupStr,
            SortStr: this.sortStr,
            IsParameterizable: this.isParameterizable,
            IsBasket: this.addToExternalApps,
            SearchAllVersions: this.searchAllVersions,
            ContentTypeIDs: this.contentTypeIDs.length == 0 ? '' : this.contentTypeIDs.join(','),
        };
    }
}
